import { observer } from "mobx-react-lite";
import { Container, Grid } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { useStore } from "../../../../app/stores/store";
import { ReportType } from "../../../../app/models/enums";
import PageHeader from "../../../../app/layout/PageHeader";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import TaxPrintDetailedTable from "./TaxPrintDetailedTable";
import TaxPrintSummaryTable from "./TaxPrintSummaryTable";

interface Props {
  startDate: Date;
  endDate: Date;
  reportType: ReportType;
}

export default observer(function Tax({
  reportType,
}: Props) {
  const { t } = useTranslation(["common", "reports"]);

  const { taxReportStore } = useStore();
  const { loadingInitial } = taxReportStore;

  if (loadingInitial)
    return (
      <LoadingComponent content={t("tax.loading", { ns: "reports" })} />
    );

  return (
    <>
      <Grid stackable columns={2} className="headerPrint">
        <Grid.Row>
          <Grid.Column>
            <PageHeader
              header={`${t("report", { ns: "reports" })}: ${t(
                "estimate.tax",
                {
                  ns: "tickets",
                }
              )}`}
              type="h2"
              divider={false}
              getAlerts={true}
              addTitle={true}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Container className="page">
          {reportType === ReportType.Detailed && <TaxPrintDetailedTable reportType={reportType} />}
          {reportType === ReportType.Summary &&  <TaxPrintSummaryTable reportType={reportType} />}
      </Container>
    </>
  );
});
